import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Box, Tooltip } from "@mui/material";

import {
  EVOTRUX_BRAND_GREEN,
  EVOTRUX_FILTER_ACTIVE_INDICATOR,
  EVOTRUX_NAVY,
  EVOTRUX_SIDEBAR_TOGGLE_BG,
  EVOTRUX_SIDEBAR_TOGGLE_BG_HOVER,
} from "constants/index";

export const COLLAPSED_RAIL_WIDTH_PX = 56;

interface Props {
  onClick: VoidFunction;
  totalCount?: number;
  hasActiveFilter?: boolean;
}

export function CollapsedShipmentRail(props: Props) {
  const { onClick, totalCount, hasActiveFilter = false } = props;

  const label =
    totalCount !== undefined ? `My Shipments (${totalCount})` : "My Shipments";
  const accessibleLabel = hasActiveFilter
    ? `Open ${label.toLowerCase()} (filters active)`
    : `Open ${label.toLowerCase()}`;

  return (
    <Tooltip title="Open your shipment list" placement="right" arrow>
      <Box
        component="button"
        type="button"
        onClick={onClick}
        aria-label={accessibleLabel}
        sx={{
          width: `${COLLAPSED_RAIL_WIDTH_PX}px`,
          minHeight: "240px",
          backgroundColor: EVOTRUX_SIDEBAR_TOGGLE_BG,
          border: "none",
          borderRadius: "4px",
          boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          py: "12px",
          px: 0,
          cursor: "pointer",
          fontFamily: '"Quicksand", "Helvetica", "Arial", sans-serif',
          transition: "background-color 0.2s, box-shadow 0.2s",
          color: EVOTRUX_NAVY,
          "&:hover": {
            backgroundColor: EVOTRUX_SIDEBAR_TOGGLE_BG_HOVER,
            boxShadow: "rgba(149, 157, 165, 0.32) 0px 8px 24px",
          },
          "&:focus-visible": {
            outline: `2px solid ${EVOTRUX_BRAND_GREEN}`,
            outlineOffset: "2px",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <ChevronRightIcon sx={{ fontSize: 26, color: EVOTRUX_BRAND_GREEN }} />
        </Box>

        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
          }}
        >
          <Box
            sx={{
              writingMode: "vertical-rl",
              transform: "rotate(180deg)",
              fontWeight: 600,
              fontSize: "15px",
              letterSpacing: "0.04em",
              color: "inherit",
              whiteSpace: "nowrap",
            }}
          >
            {label}
          </Box>

          {hasActiveFilter && (
            <Box
              sx={{
                position: "absolute",
                top: "8px",
                left: "50%",
                transform: "translateX(-50%)",
                width: "8px",
                height: "8px",
                borderRadius: "50%",
                backgroundColor: EVOTRUX_FILTER_ACTIVE_INDICATOR,
              }}
            />
          )}
        </Box>
      </Box>
    </Tooltip>
  );
}
